import { useCallback, useEffect, useState } from "react";
import { Navigate, useBlocker } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";

import { Stack } from "types/generated";
import { showBlockNavigationModal } from "hooks/useBlockNavigationModal/BlockNavigationModal";

import StackTaskForm from "./Form";

type NewTaskFormProps = {
  stackId: Stack["id"];
  accessErrorMessage?: string;
};

const NewTaskForm = ({ stackId, accessErrorMessage }: NewTaskFormProps) => {
  const form = useForm({
    mode: "onChange",
    defaultValues: {
      commandValue: "",
      skipInitialization: false,
    },
  });
  const { watch } = form;
  const commandValue = watch("commandValue");

  const [nextUrl, setNextUrl] = useState<string | undefined>(undefined);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      !nextUrl && !!commandValue && currentLocation.pathname !== nextLocation.pathname
  );

  const onNavigationConfirm = useCallback(() => {
    blocker?.proceed?.();
  }, [blocker]);

  useEffect(() => {
    if (blocker.state === "blocked" && !nextUrl)
      showBlockNavigationModal({ onConfirm: onNavigationConfirm });
  }, [blocker, onNavigationConfirm, nextUrl]);

  if (nextUrl) {
    blocker.proceed?.();
    return <Navigate to={nextUrl} replace />;
  }

  return (
    <FormProvider {...form}>
      <StackTaskForm
        setNextUrl={setNextUrl}
        stackId={stackId}
        accessErrorMessage={accessErrorMessage}
      />
    </FormProvider>
  );
};

export default NewTaskForm;
